module.exports = __webpack_public_path__ + "/images/ico-color-hucha.d353131.svg";